import { render, staticRenderFns } from "./ViewNotifications.vue?vue&type=template&id=331d0398&scoped=true"
import script from "./ViewNotifications.vue?vue&type=script&lang=js"
export * from "./ViewNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d0398",
  null
  
)

export default component.exports